import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHelper } from 'src/app/common/index';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TicketService {

  constructor(public httpHelper: HttpHelper,
              private http: HttpClient) {

  }

  getAllTickets(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets`, params);
  }

  getAllOpenedTickets(params):Observable<any> {
    return this.httpHelper.postRequest('/tickets/opened', params);
  }

  getAllAssignedToMeTickets(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/assigned`, params);
  }

  getReplies(id):Observable<any> {
    return this.httpHelper.getRequest(`/tickets/replies/${id}`);
  }

  get(id):Observable<any> {
    return this.httpHelper.getRequest(`/tickets/${id}`);
  }

  createTicket(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/create`, params);
  }

  getAssignedToMe(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/get/assigned/to/me`, params);
  }

  getAssignedToMeNew(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/get/assigned/to/me/new`, params);
  }

  createTicketReply(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/create/reply`, params);
  }

  saveFile(file):Observable<any> {
    return this.httpHelper.postFile(`/tickets/files`,file);
  }

  changeArt(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/change/art`, params);
  }

  changeStatus(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/change/status`, params);
  }

  changeGroup(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/change/group`, params);
  }

  changeCategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/change/category`, params);
  }

  changeSubcategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/change/subcategory`, params);
  }

  changeAssignedUser(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/change/assigned/user`, params);
  }

  createTicketGroup(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/create/group`, params);
  }

  getAllTicketsGroups():Observable<any> {
    return this.httpHelper.getRequest('/tickets/get/all/groups');
  }

  getAllLogs(params):Observable<any> {
    return this.httpHelper.postRequest(`/logs/all`,params);
  }

  getTicketsGroup(groupId):Observable<any> {
    return this.httpHelper.getRequest(`/tickets/get/all/groups/${groupId}`);
  }

  getTicketsCategoryUsers(groupId):Observable<any> {
    return this.httpHelper.getRequest(`/tickets/get/all/category/users/${groupId}`);
  }

  getEmployees():Observable<any> {
    return this.httpHelper.getRequest(`/employees`);
  }

  saveGroupUser(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/save/user/to/group`, params);
  }

  getAllTicketsUsersGroups():Observable<any> {
    return this.httpHelper.getRequest('/tickets/get/all/users/to/group');
  }

  deleteGroupUser(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/delete/users/to/group`, params);
  }

  getTicketsCategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/get/all/category`, params);
  }

  deleteSingleGroup(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/delete/single/group`, params);
  }

  addSubcategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/add/subcategory/category`, params);
  }

  getAllTicketsCategory(params):Observable<any> {
    return this.httpHelper.postRequest('/tickets/get/all/category', params);
  }

  createNewCategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/create/new/category`, params);
  }

  deleteSingleCategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/delete/single/category`, params);
  }

  deleteSingleSubcategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/delete/single/subcategory`, params);
  }

  createCategoryGroups(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/create/relation/category/group`, params);
  }

  createSubcategoryCategory(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/create/relation/subcategory/category`, params);
  }
  deleteCategoryGroups(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/delete/relation/category/group`, params);
  }

  createTicketNote(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/create/new/note`, params);
  }

  getHistoryTicketNote(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/get/history/of/note`, params);
  }

  getNumberHistoryTicketNote(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/get/number/of/history/of/note`, params);
  }

  checkForSimilarTickets(params):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/get/similar/tickets/by/title`, params);
  }

  getStatusTypes(lang: string): Observable<any> {
    return this.httpHelper.getRequest(`/tickets/status-types?lang=${lang}`);
  }

  getArtTypes(lang: string): Observable<any> {
    return this.httpHelper.getRequest(`/tickets/art-types?lang=${lang}`);
  }

}
